/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap, jsx } from '@atlaskit/css';

import messages from './messages';
import { PageNotFoundSVG } from '../assets/PageNotFoundSVG';

const styles = cssMap({
	image: {
		maxWidth: '300px',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
});

// Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const PreviewPanelPageNotFoundSVG = () => {
	return (
		<Box xcss={styles.image}>
			<PageNotFoundSVG />
		</Box>
	)
}

type PageNotFoundEmptyStateProps = {
	embeddedConfluenceSource?: string;
}

export const PageNotFoundEmptyState = ({ embeddedConfluenceSource }: PageNotFoundEmptyStateProps = {}) => {
	const { formatMessage } = useIntl();

	const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
	const EmptyStateImage = isInPreviewPanel ? PreviewPanelPageNotFoundSVG : PageNotFoundSVG;
	const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';

	return (
		<EmptyState
			header={formatMessage(messages.emptyStateHeader)}
			description={formatMessage(messages.emptyStateDescription)}
			width={EmptyStateWidth}
			renderImage={() => <EmptyStateImage />}
		/>
	);
};
